import React from "react";
import { AlertCircle, X } from "lucide-react";

/**
 * Professional error message component
 * Used for displaying error states across the application
 */
const ErrorMessage = ({
  message,
  onDismiss,
  type = "error",
  className = "",
}) => {
  const typeStyles = {
    error: "bg-red-50 border-red-200 text-red-800",
    warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
    info: "bg-blue-50 border-blue-200 text-blue-800",
  };

  const iconColors = {
    error: "text-red-500",
    warning: "text-yellow-500",
    info: "text-blue-500",
  };

  return (
    <div
      className={`
        flex items-start gap-3 p-4 rounded-lg border
        ${typeStyles[type]}
        ${className}
      `}
      role="alert"
    >
      <AlertCircle
        className={`w-5 h-5 flex-shrink-0 mt-0.5 ${iconColors[type]}`}
      />

      <div className="flex-1 text-sm">{message}</div>

      {onDismiss && (
        <button
          onClick={onDismiss}
          className="flex-shrink-0 p-1 rounded-md hover:bg-black/5 transition-colors"
          aria-label="Dismiss error"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;


